let overlay = document.querySelector('.js-overlay');

document.addEventListener('scroll', () => {
   if(window.scrollY > 300) {
       overlay.classList.remove('overlay');
   } else {
       overlay.classList.add('overlay')
   }
});